import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import CardLeftRight from "../../components/cardleftright";
import { dataListsType } from "../../components/featured-posts";
import AdPage from "../../components/AdPage";
import { DataLists } from "../../dataLists/DataLists";

interface HotelSectionProps {
  hotelsData: dataListsType[];
  nation: string;
}

const HotelSection = ({ nation, hotelsData }: HotelSectionProps) => (
  <div className="w-full mb-16 px-8">
    <div className="mb-8 border-b-[1px]">
      <h5 className="uppercase text-xs font-semibold pt-2 pb-2 tracking-widest flex justify-between">
        <span>{nation} Hotels</span>
        <Link
          className="font-bold text-[#4d5bcc]"
          to={{
            pathname: "/morepage",
            search: `?category=Hotels&nation=${encodeURIComponent(
              nation
            )}&label=${encodeURIComponent(`${nation} Hotels`)}`,
          }}
        >
          MORE{">>"}
        </Link>
      </h5>
      <span className="block w-14 h-[3px] bg-black"></span>
    </div>
    <div className="w-full flex flex-col gap-y-10">
      <CardLeftRight props={hotelsData.slice(0, 2)} />
    </div>
  </div>
);

export default function Hotels() {
  const [hotelsData, setHotelsData] = useState<{
    Indonesia: dataListsType[];
    China: dataListsType[];
    Japan: dataListsType[];
    // Singapore: dataListsType[];
  }>({
    Indonesia: [],
    China: [],
    Japan: [],
    // Singapore: [],
  });

  useEffect(() => {
    const allData = DataLists.filter((item) => item.category === "Hotels");
    setHotelsData({
      // Singapore: allData.filter((item) => item.nation === "Singapore"),
      Indonesia: allData.filter((item) => item.nation === "Indonesia"),
      Japan: allData.filter((item) => item.nation === "Japan"),
      China: allData.filter((item) => item.nation === "China"),
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Hotels in Asia - Find Best Accommodations & Places to Stay
        </title>
        <meta
          name="description"
          content="Find the perfect accommodation in Asia, from luxury hotels to budget-friendly stays in China, Japan, Indonesia and more. Detailed reviews and booking guides."
        />
      </Helmet>
      <Header />
      <Navbar />
      <AdPage />
      <div className="w-full flex justify-center">
        <div className="flex flex-col justify-center max-w-[888px] my-8">
          <h1 className="text-3xl font-extrabold px-8 pb-3">Hotels</h1>
          {Object.entries(hotelsData).map(([nation, data]) => (
            <HotelSection key={nation} nation={nation} hotelsData={data} />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
